import type { FC } from "react";

type TitleProps = {
  title: string;
  subTitle: string;
  className: string | undefined;
};

const Title: FC<TitleProps> = ({ title, subTitle, className }) => {
  return (
    <div className={className}>
      <h2 className="font-semibold text-[32px]">{title}</h2>
      <div className="text-xs text-gray-600">{subTitle}</div>
    </div>
  );
};

export default Title;
